import {
  CustomImageField,
  RichTextField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field } from "redux-form"

const InformationTab = ({ allEventsCalendar }) => {
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>INFORMATION</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-2">
              <label>Add to Calendar: </label>
            </Col>
            <Col xs="auto">
              <div style={{ minWidth: "300px" }}>
                <Field
                  name="calendar"
                  component={SingleSelectField}
                  options={allEventsCalendar?.map(calendar => ({
                    value: calendar?.id,
                    label: calendar?.name,
                  }))}
                />
              </div>
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto" className="mt-2" style={{ minWidth: "135px" }}>
              <label>Event Title: </label>
            </Col>
            <Col xs="auto">
              <Field name="title" component={TextField} placeholder="Title" />
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto" className="mt-2" style={{ minWidth: "135px" }}>
              <label>Image: </label>
            </Col>
            <Col xs="auto">
              <Field name="image" component={CustomImageField} />
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto" className="mt-2" style={{ minWidth: "135px" }}>
              <label>Description: </label>
            </Col>
            <Col xs="auto">
              <Field name="description" component={RichTextField} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  allEventsCalendar: state.Events.allEventsCalendar,
})

export default connect(mapStateToProps)(InformationTab)
